var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useState } from 'react';
import { getRequiredSettings } from '../../api/apiUtils';
export function useManualLookup() {
    var _this = this;
    var _a = useState(false), isLoading = _a[0], setIsLoading = _a[1];
    var _b = useState(null), error = _b[0], setError = _b[1];
    var _c = useState([]), vehicles = _c[0], setVehicles = _c[1];
    var lookupVehicle = function (params) { return __awaiter(_this, void 0, void 0, function () {
        var _a, restUrl, restNonce, response, result, rawVehicles, vehiclesList, err_1, errorMessage;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setIsLoading(true);
                    setError(null);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 4, 5, 6]);
                    _a = getRequiredSettings(), restUrl = _a.restUrl, restNonce = _a.restNonce;
                    return [4 /*yield*/, fetch("".concat(restUrl, "/manual-vehicle-lookup"), {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                'X-WP-Nonce': restNonce
                            },
                            body: JSON.stringify({
                                manufacturer: params.manufacturer,
                                model: params.model,
                                year: params.year,
                                series: params.series,
                                variant: params.series,
                                rego: params.rego,
                                state: params.state
                            })
                        })];
                case 2:
                    response = _b.sent();
                    return [4 /*yield*/, response.json()];
                case 3:
                    result = _b.sent();
                    if (!result.success) {
                        throw new Error(result.error || 'Failed to lookup vehicle');
                    }
                    // Handle the response data
                    if (result.data) {
                        rawVehicles = void 0;
                        if (Array.isArray(result.data)) {
                            rawVehicles = result.data;
                        }
                        else if (Array.isArray(result.data.vehicles)) {
                            rawVehicles = result.data.vehicles;
                        }
                        else if (result.data.vehicles) {
                            rawVehicles = [result.data.vehicles];
                        }
                        else {
                            rawVehicles = [result.data];
                        }
                        vehiclesList = rawVehicles.map(function (vehicle) {
                            var _a, _b, _c, _d;
                            return ({
                                model: vehicle.Model || vehicle.model || params.model || '',
                                badge: vehicle.Badge || vehicle.badge || params.series || '',
                                manufacturer: vehicle.Manufacturer || vehicle.manufacturer || params.manufacturer || '',
                                manufactureYear: vehicle.ManufactureYear || vehicle.year || params.year || '',
                                badgeCategoryID: vehicle.BadgeCategoryID || vehicle.badgeCategoryId || '',
                                bodyType: vehicle.BodyType || vehicle.bodyType || '',
                                cylinders: ((_a = vehicle.Cylinders) === null || _a === void 0 ? void 0 : _a.toString()) || ((_b = vehicle.cylinders) === null || _b === void 0 ? void 0 : _b.toString()) || '',
                                description: vehicle.Description || "".concat(params.manufacturer, " ").concat(params.model, " ").concat(params.series),
                                doorCount: ((_c = vehicle.DoorCount) === null || _c === void 0 ? void 0 : _c.toString()) || ((_d = vehicle.doors) === null || _d === void 0 ? void 0 : _d.toString()) || '',
                                driveType: vehicle.DriveType || vehicle.driveType || '',
                                engineSize: vehicle.EngineSize || vehicle.engineSize || '',
                                fuelTypeBasic: vehicle.FuelTypeBasic || vehicle.fuelType || '',
                                fuelTypeBasicCategoryID: vehicle.FuelTypeBasicCategoryID || vehicle.fuelTypeId || '',
                                imageUrl: vehicle.ImageUrl || vehicle.imageUrl || '',
                                manufacturerCategoryID: vehicle.ManufacturerCategoryID || vehicle.manufacturerId || 0,
                                modelCategoryID: vehicle.ModelCategoryID || vehicle.modelId || 0,
                                seatCount: vehicle.SeatCount || vehicle.seats || 0,
                                series: vehicle.Series || vehicle.series || params.series || '',
                                seriesCategoryID: vehicle.SeriesCategoryID || vehicle.seriesId || 0,
                                thumbUrl: vehicle.ThumbUrl || vehicle.thumbUrl || '',
                                transmissionTypeBasic: vehicle.TransmissionTypeBasic || vehicle.transmission || '',
                                transmissionTypeBasicCategoryID: vehicle.TransmissionTypeBasicCategoryID || vehicle.transmissionId || '',
                                variantCode: vehicle.VariantCode || vehicle.id || "".concat(params.manufacturer, "-").concat(params.model, "-").concat(params.series, "-").concat(params.year)
                            });
                        });
                        // Update state
                        setVehicles(vehiclesList);
                        return [2 /*return*/, vehiclesList];
                    }
                    // If no data, return empty array
                    setVehicles([]);
                    return [2 /*return*/, []];
                case 4:
                    err_1 = _b.sent();
                    errorMessage = err_1 instanceof Error ? err_1.message : 'An error occurred while looking up the vehicle';
                    setError(errorMessage);
                    setVehicles([]);
                    return [2 /*return*/, []];
                case 5:
                    setIsLoading(false);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    return { isLoading: isLoading, error: error, vehicles: vehicles, lookupVehicle: lookupVehicle };
}
